export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}

export function param2Obj(url) {
  const search = url.split('?')[1];
  if (!search) {
    return {};
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
}

export function formatTime(time, option) {
  time = +time * 1000;
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' +
      d.getMinutes() + '分';
  }
}

export function deepClone(obj) {
  const proto = Object.getPrototypeOf(obj);
  return Object.assign(obj instanceof Array ? [] : {}, Object.create(proto), obj);
}

export function pakageImg(obj) {
  return `/fileOper/show/${obj.targetId}
          /${obj.fileType}/${obj.sign}/${obj.ts}`;
}

export function compressString(strNormalString) {
  var strCompressedString = '';

  var ht = new Array();
  for (i = 0; i < 128; i++) {
    ht[i] = i;
  }

  var used = 128;
  var intLeftOver = 0;
  var intOutputCode = 0;
  var pcode = 0;
  var ccode = 0;
  var k = 0;

  for (var i = 0; i < strNormalString.length; i++) {
    ccode = strNormalString.charCodeAt(i);
    k = (pcode << 8) | ccode;
    if (ht[k] != null) {
      pcode = ht[k];
    } else {
      intLeftOver += 12;
      intOutputCode <<= 12;
      intOutputCode |= pcode;
      pcode = ccode;
      if (intLeftOver >= 16) {
        strCompressedString += String.fromCharCode(intOutputCode >> (intLeftOver - 16));
        intOutputCode &= (Math.pow(2, (intLeftOver - 16)) - 1);
        intLeftOver -= 16;
      }
      if (used < 4096) {
        used++;
        ht[k] = used - 1;
      }
    }
  }

  if (pcode != 0) {
    intLeftOver += 12;
    intOutputCode <<= 12;
    intOutputCode |= pcode;
  }

  if (intLeftOver >= 16) {
    strCompressedString += String.fromCharCode(intOutputCode >> (intLeftOver - 16));
    intOutputCode &= (Math.pow(2, (intLeftOver - 16)) - 1);
    intLeftOver -= 16;
  }

  if (intLeftOver > 0) {
    intOutputCode <<= (16 - intLeftOver);
    strCompressedString += String.fromCharCode(intOutputCode);
  }
  return strCompressedString;
}

export function decompressString(strCompressedString) {
  var strNormalString = "";
  var ht = new Array();

  for(i = 0; i < 128; i++) {
    ht[i] = String.fromCharCode(i);
  }

  var used = 128;
  var intLeftOver = 0;
  var intOutputCode = 0;
  var ccode = 0;
  var pcode = 0;
  var key = 0;

  for(var i=0; i<strCompressedString.length; i++) {
    intLeftOver += 16;
    intOutputCode <<= 16;
    intOutputCode |= strCompressedString.charCodeAt(i);

    while(1) {
      if(intLeftOver >= 12) {
        ccode = intOutputCode >> (intLeftOver - 12);
        if( typeof( key = ht[ccode] ) != "undefined" ) {
          strNormalString += key;
          if(used > 128) {
            ht[ht.length] = ht[pcode] + key.substr(0, 1);
          }
          pcode = ccode;
        } else {
          key = ht[pcode] + ht[pcode].substr(0, 1);
          strNormalString += key;
          ht[ht.length] = ht[pcode] + key.substr(0, 1);
          pcode = ht.length - 1;
        }

        used ++;
        intLeftOver -= 12;
        intOutputCode &= (Math.pow(2,intLeftOver) - 1);
      } else {
        break;
      }
    }
  }
  return strNormalString;
}

/**
 * 新官网 URL（同源部署，相对路径，不带域名）
 * - 老官网（front-saas 内嵌的 NotariaIndex 等页面）已下线，业务统一跳到独立部署的新官网（front-www）。
 * - 部署拓扑：新官网在 '/'（根路径），saas 在 '/web'，boss 在 '/boss'，三者同源。
 *   故跳新官网直接用 '/' 或 '/guide-detail' 等相对路径，浏览器自动按当前域名拼接，
 *   无需在代码里维护任何域名/映射。
 * - 详情类带参数跳转（如 /guide-detail?tag=xxx）仍按需带上 query，调用方拼接 path/query 即可。
 */

/**
 * 新官网首页 URL（相对路径 '/'，跟随当前域名）
 */
export function getWebHomeUrl() {
  return '/'
}

/**
 * 拼接新官网任意路径的完整 URL（相对路径）。
 *
 * @param {string} path 新官网路径，例如 '/' 或 '/guide-detail'
 * @param {object} [query] 可选 query 参数
 */
export function buildNewWebUrl(path, query) {
  let url = path || '/'
  if (query) {
    const qs = Object.keys(query)
      .filter(k => query[k] !== undefined && query[k] !== null && query[k] !== '')
      .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(query[k])}`)
      .join('&')
    if (qs) url += '?' + qs
  }
  return url
}

export function formatFileSize(value, precision) {
  if(!value) return 0 + "KB"
  if (typeof precision !== "number") {
    precision = 2;
  }
  var absValue = Math.abs(value)
  if (absValue > Math.pow(1024, 5)) {
    return (value / Math.pow(1024, 5)).toFixed(precision) + "PB";
  } else if (absValue > Math.pow(1024, 4)) {
    return (value / Math.pow(1024, 4)).toFixed(precision) + "TB";
  } else if (absValue > Math.pow(1024, 3)) {
    return (value / Math.pow(1024, 3)).toFixed(precision) + "GB";
  } else if (absValue > Math.pow(1024, 2)) {
    return (value / Math.pow(1024, 2)).toFixed(precision) + "MB";
  } else if (absValue > Math.pow(1024, 1)){
    return (value / 1024).toFixed(precision) + "KB";
  } else {
    return (value / 1024).toFixed(precision) + "B";
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js